import React from 'react'
import { Link, type LinkProps } from 'react-router-dom'

import Button from '../../components/ui/button'

const StaticLinksContext = React.createContext(false)

export const StaticLinksProvider = ({ children }: { children: React.ReactNode }) => (
  <StaticLinksContext.Provider value={true}>{children}</StaticLinksContext.Provider>
)

export function useStaticLinks(): boolean {
  return React.useContext(StaticLinksContext)
}

type PostLinkProps = Omit<LinkProps, 'to'> & {
  to: string
}

/** Router link in the app; plain anchor when generating static HTML. */
export function PostLink({ to, children, className, ...rest }: PostLinkProps) {
  const staticLinks = useStaticLinks()
  if (staticLinks) {
    return (
      <a href={to} className={className} {...rest}>
        {children}
      </a>
    )
  }
  return (
    <Link to={to} className={className} {...rest}>
      {children}
    </Link>
  )
}

export function PostCta() {
  const staticLinks = useStaticLinks()
  if (staticLinks) {
    return (
      <a href='/login' className='btn btn-primary button'>
        Create Invoice for FREE
      </a>
    )
  }
  return (
    <Link to='/login'>
      <Button>Create Invoice for FREE</Button>
    </Link>
  )
}

export function PostCtaBlock() {
  return (
    <div className='d-flex flex-column text-center gap-2'>
      <PostCta />
      <small><i>No credit card required</i></small>
    </div>
  )
}
